import { render, staticRenderFns } from "./PInput.vue?vue&type=template&id=7e138468&scoped=true&"
import script from "./PInput.vue?vue&type=script&lang=js&"
export * from "./PInput.vue?vue&type=script&lang=js&"
import style0 from "./PInput.vue?vue&type=style&index=0&id=7e138468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e138468",
  null
  
)

export default component.exports